export const GET_MESSAGE_SEGMENTS_REQ = "GET_MESSAGE_SEGMENT_REQ";
export const GET_MESSAGE_SEGMENTS_SUCCESS = "GET_MESSAGE_SEGMENT_SUCCESS";
export const GET_MESSAGE_SEGMENTS_FAIL = "GET_MESSAGE_SEGMENT_FAIL";

export const GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS =
  "GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS";
export const GET_OVERALL_MESSAGE_SEGMENTS_FAIL =
  "GET_OVERALL_MESSAGE_SEGMENTS_FAIL";

export const CREATE_MESSAGE_SEGMENT_REQ = "CREATE_MESSAGE_SEGMENT_REQ";
export const CREATE_MESSAGE_SEGMENT_SUCCESS = "CREATE_MESSAGE_SEGMENT_SUCCESS";
export const CREATE_MESSAGE_SEGMENT_FAIL = "CREATE_MESSAGE_SEGMENT_FAIL";
export const CREATE_MESSAGE_SEGMENT_RESET = "CREATE_MESSAGE_SEGMENT_RESET";

export const UPDATE_MESSAGE_SEGMENT_REQ = "UPDATE_MESSAGE_SEGMENT_REQ";
export const UPDATE_MESSAGE_SEGMENT_SUCCESS = "UPDATE_MESSAGE_SEGMENT_SUCCESS";
export const UPDATE_MESSAGE_SEGMENT_FAIL = "UPDATE_MESSAGE_SEGMENT_FAIL";
export const UPDATE_MESSAGE_SEGMENT_RESET = "UPDATE_MESSAGE_SEGMENT_RESET";

export const DELETE_MESSAGE_SEGMENT_REQ = "DELETE_MESSAGE_SEGMENT_REQ";
export const DELETE_MESSAGE_SEGMENT_SUCCESS = "DELETE_MESSAGE_SEGMENT_SUCCESS";
export const DELETE_MESSAGE_SEGMENT_FAIL = "DELETE_MESSAGE_SEGMENT_FAIL";
